/** Simple table for data.by_campaign_content, sorted by amount desc
 * (already sorted server-side). */
export default function DiwaliCampaignContentTable({ data }) {
  const rows = data?.by_campaign_content || [];
  return (
    <div className="bg-amtm-surface border border-amtm-border rounded-xl p-4 mb-6" data-testid="diwali-campaign-content-table">
      <p className="font-semibold text-amtm-text mb-3">By Campaign &amp; Content</p>
      {rows.length === 0 ? (
        <p className="text-amtm-textMuted text-sm py-6 text-center" data-testid="diwali-campaign-content-empty">No data for this range yet.</p>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-amtm-textMuted border-b border-amtm-border">
              <th className="p-2">UTM Campaign</th>
              <th className="p-2">UTM Content</th>
              <th className="p-2">Amount</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-amtm-border">
            {rows.map((r, i) => (
              <tr key={i} data-testid={`diwali-campaign-content-row-${i}`}>
                <td className="p-2">{r.utm_campaign}</td>
                <td className="p-2">{r.utm_content}</td>
                <td className="p-2 font-semibold text-amtm-success">₹{Number(r.amount).toLocaleString("en-IN")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
